import { render, staticRenderFns } from "./ClaimRejectedTable.vue?vue&type=template&id=7b8990f2"
import script from "./ClaimRejectedTable.vue?vue&type=script&lang=js"
export * from "./ClaimRejectedTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports